import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_EditorContent = _resolveComponent("EditorContent");
    const _component_CreateCommentButton = _resolveComponent("CreateCommentButton");
    return (_openBlock(), _createElementBlock("div", {
        ref: "editorContainer",
        class: "text-editor-container",
        style: _normalizeStyle(_ctx.cursorStyle),
        "data-external": "editor-view-text-editor-container"
    }, [
        _createVNode(_component_EditorContent, {
            editor: _ctx.viewer,
            spellcheck: "false"
        }, null, 8, ["editor"]),
        (_ctx.showCreateCommentButton)
            ? (_openBlock(), _createBlock(_component_CreateCommentButton, {
                key: 0,
                position: _ctx.createCommentButtonPosition,
                state: _ctx.createContextualCommentButtonState,
                onClick: _ctx.createComment
            }, null, 8, ["position", "state", "onClick"]))
            : _createCommentVNode("", true)
    ], 4));
}
